import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { EnvironmentMenuComponent } from './environment-menu.component';

@NgModule({
    imports: [SharedModule],
    declarations: [EnvironmentMenuComponent],
    entryComponents: [EnvironmentMenuComponent],
    exports: [EnvironmentMenuComponent]
})
export class EnvironmentMenuModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/environmentDetails/environment-menu/environment-menu.module.ts